import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartWithEbook: false,   // Trigger the store when is loaded the cart
  productsLine: null
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setHasEbookOff: (state)=>{
      state.cartWithEbook = false;
    },
    triggerHasEbook: (state)=>{
      state.cartWithEbook = true;
    },
    setProductsLine:(state, data)=>{
      state.productsLine = data.playload;
      state.cartWithEbook = true;
    }
  },
});

export const {
  setHasEbookOff,
  triggerHasEbook,
  setProductsLine
} = cartSlice.actions;

export default cartSlice.reducer;